
import { defineComponent } from "vue";

export default defineComponent({
  name: "Modal",
  emits: ["close"],
  setup(props, { emit }) {
    const close = () => {
      emit("close");
    };

    return { close };
  },
});
